import React from "react";
import { DarkButton } from "./element";
import { SiGitbook } from "react-icons/si";
import { IoIosArrowForward } from "react-icons/io";

interface BtnProps {
  btnText: string;
  navigate?: string;
  bookIcon?: boolean;
  arrowIcon?: boolean;
}

const DarkBtnComp: React.FC<BtnProps> = ({
  btnText,
  navigate,
  bookIcon,
  arrowIcon,
}) => {
  const handleButtonClick = () => {
    if (navigate === "gitbook") {
      window.open("https://www.gitbook.com", "_blank");
    }
  };
  return (
    <DarkButton onClick={handleButtonClick}>
      {bookIcon && <SiGitbook className="book-icon" />}
      {btnText}
      {arrowIcon && <IoIosArrowForward className="arrow-icon" />}
    </DarkButton>
  );
};

export default DarkBtnComp;
